import { ShopsApiClient } from '@fourthwall/services/dist/ShopsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateShopCurrencySettingsMutation = createMutationHook(
  ShopsApiClient.updateCurrencySettings,
  {
    mutationKey: ['updateShopCurrencySettings'],
  },
)
